<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-row>
        <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
          <div class="title_page ma-3">
            <h4 class="breadcrumb_title_page">คลังสินค้า</h4>
            <v-breadcrumbs :items="sub_menu">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>
          </div>
      </v-col>
        <v-col xs="12" sm="12" md="4" lg="2" xl="2" cols="12">
          <div class="title_page ma-3">
              <v-btn type="button" class="btn_add_data" elevation="4" @click="link('/arin/pos/historyimportinventory')"
              large>เพิ่มสินค้าเข้าคลัง</v-btn>
          </div>
        </v-col>
      </v-row>

      <v-card elevation="4">
        <v-card-text>
          <v-row>
            <v-col xs="12" sm="6" md="8" lg="8" xl="8" cols="12">
              <v-tabs v-model="active_tab_id"  color="#D6BFAF">
                <v-tab @click="tabs(1) ">คลังปกติ</v-tab>
                <v-tab @click="tabs(2)">คลังใกล้หมดอายุ</v-tab>
              </v-tabs>
            </v-col>
            <v-col xs="12" sm="6" md="4" lg="4" xl="4" cols="12">
              <v-text-field color="#D6BFAF" class="input-radius" append-icon="mdi-magnify" hide-details="auto" required
                v-model="search" placeholder="ค้นหา..." single-line outlined dense></v-text-field>
            </v-col>
            <v-col v-if="tab_id === 1" xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
              <div style="float:right;">
                <v-badge color="orange" inline dot></v-badge>
                จำนวนสินค้าต่ำกว่า Min
                <v-badge color="red" inline dot></v-badge>
                จำนวนสินค้าหมดคลัง/ติดลบ
              </div>
            </v-col>
            <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
              <v-data-table :headers="headers" :items="data_list" :search="search" :footer-props="footer_Props"
                mobile-breakpoint="0">
                <template v-slot:item="dataDetail">
                  <tr>
                    <td class="hidden_line" v-if="dataDetail.item.product_code">
                      <div v-if="dataDetail.item.in_stock <= 0" class="red--text">
                        {{ dataDetail.item.product_code }}
                      </div>
                      <div v-else-if="dataDetail.item.in_stock <= dataDetail.item.min" class="warning--text">
                        {{ dataDetail.item.product_code }}
                      </div>
                      <div v-else>
                        {{ dataDetail.item.product_code }}
                      </div>
                    </td>
                    <td class="hidden_line">
                      <div v-if="dataDetail.item.in_stock <= 0" class="red--text">
                        {{ dataDetail.item.name }}
                      </div>
                      <div v-else-if="dataDetail.item.in_stock <= dataDetail.item.min" class="warning--text">
                        {{ dataDetail.item.name }}
                      </div>
                      <div v-else>
                        {{ dataDetail.item.name }}
                      </div>
                    </td>
                    <td class="hidden_line">
                      <div v-if="dataDetail.item.in_stock <= 0" class="red--text">
                        {{ dataDetail.item.name_sci }}
                      </div>
                      <div v-else-if="dataDetail.item.in_stock <= dataDetail.item.min" class="warning--text">
                        {{ dataDetail.item.name_sci }}
                      </div>
                      <div v-else>
                        {{ dataDetail.item.name_sci }}
                      </div>
                    </td>
                    <td class="hidden_line">
                      <div v-if="dataDetail.item.in_stock <= 0" class="red--text">
                        {{ dataDetail.item.in_stock }}
                      </div>
                      <div v-else-if="dataDetail.item.in_stock <= dataDetail.item.min" class="warning--text">
                        {{ dataDetail.item.in_stock }}
                      </div>
                      <div v-else>
                        {{ dataDetail.item.in_stock }}
                      </div>
                    </td>
                    <td class="hidden_line">
                      <div v-if="dataDetail.item.in_stock <= 0" class="red--text">
                        {{ dataDetail.item.unit_name }}
                      </div>
                      <div v-else-if="dataDetail.item.in_stock <= dataDetail.item.min" class="warning--text">
                        {{ dataDetail.item.unit_name }}
                      </div>
                      <div v-else>
                        {{ dataDetail.item.unit_name }}
                      </div>
                    </td>
                    <td class="hidden_line">
                      <v-btn v-if="tab_id === 2" elevation="4" class="ma-2" outlined color="#88B358"
                        style="border-radius: 10px;" title="ตั้งราคาขาย" @click="product_expired_store_id = dataDetail.item.id,price_new_dialog()">
                        <v-icon>mdi-tag-check-outline</v-icon> ตั้งราคาขาย
                      </v-btn>
                      <v-btn v-if="tab_id === 1" elevation="4" class="ma-2" outlined color="#8EBBDC" style="border-radius: 10px;"
                        @click="link('/arin/pos/inventorydetail/' + dataDetail.item.id+'?status=0');" title="ดูรายละเอียด">
                        <v-icon>mdi-magnify</v-icon> ดูรายละเอียด
                      </v-btn>
                      <v-btn v-else elevation="4" class="ma-2" outlined color="#8EBBDC" style="border-radius: 10px;"
                        @click="link('/arin/pos/inventorydetail/' + dataDetail.item.id+'?status=1');" title="ดูรายละเอียด">
                        <v-icon>mdi-magnify</v-icon> ดูรายละเอียด
                      </v-btn>
                      <v-btn elevation="4" class="ma-2" outlined color="#FEA06C" style="border-radius: 10px;"
                        title="ย้ายคลัง" @click="inventory_remove_dialog(), tab_id == 1 ? product_id = dataDetail.item.id : product_id = dataDetail.item.product_id, product_expired_store_id = dataDetail.item.id">
                        <v-icon>mdi-arrow-right-top</v-icon>ย้ายคลัง
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-dialog v-model="inventory_remove" persistent max-width="580">
        <v-card>
          <div class="d-flex justify-space-between">
            <v-card-title>
              <b>ย้ายสินค้าออกจากคลัง</b>
            </v-card-title>
            <v-btn icon class="ma-4" @click="inventory_remove = false">
              <v-icon color="grey">mdi-close</v-icon>
            </v-btn>
          </div>
            <v-form ref="exportInventory" @submit.prevent="exportInventory()">
          <v-card-text>
              <v-row>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-form-group>
                    <label class="label_form_text">ย้ายสินค้า <span class="required--text">*</span></label>
                    <v-autocomplete class="input-radius" :items="tab_id == 1 ? [
        { id: 1, product_name: 'สินค้าทิ้ง', value: 2 },
        { id: 2, product_name: 'คลังใกล้หมดอายุ', value: 1 },
      ] : 
      [
        { id: 1, product_name: 'สินค้าทิ้ง', value: 2 },
      ]" item-text="product_name" item-value="id"
                      v-model="export_type" :rules="[v => !!v || 'กรุณาเลือกการย้ายสินค้า']" hide-details="auto"
                      placeholder="กรุณาเลือกการย้ายสินค้า" single-line outlined dense required></v-autocomplete>
                  </v-form-group>
                </v-col>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-form-group>
                    <label class="label_form_text">จำนวนสินค้า <span class="required--text">*</span></label>
                    <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-cube" hide-details="auto"
                      v-model="export_count" @keypress="isNumber($event, product_qty)" @paste="isPaste($event)"
                      :rules="[v => !!v || 'กรุณากรอกจำนวนสินค้า']" placeholder="กรุณากรอกจำนวนสินค้า" single-line
                      outlined dense required></v-text-field>
                  </v-form-group>
                </v-col>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <v-form-group>
                    <label class="label_form_text">สาเหตุการย้ายสินค้า <span class="required--text">*</span></label>
                    <v-textarea :rules="[v => !!v || 'กรุณากรอกสาเหตุการย้ายสินค้า']" v-model="detail"
                      placeholder="กรุณากรอกสาเหตุการย้ายสินค้า" single-line outlined dense required></v-textarea>
                  </v-form-group>
                </v-col>
              </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn type="submit" class="btn_add_data_submit" elevation="4" large>บันทึก</v-btn>
          </v-card-actions>
            </v-form>
        </v-card>
      </v-dialog>

      <!-- ตั้งราคาใหม่ -->
      <v-dialog v-model="price_new" persistent max-width="778">
        <v-card>
          <div class="d-flex justify-space-between">
            <v-card-title>
              <b>ตั้งราคาขายใหม่</b>
            </v-card-title>
            <v-btn icon class="ma-4" @click="price_new = false">
              <v-icon color="grey">mdi-close</v-icon>
            </v-btn>
          </div>
            <v-form ref="addBarcode" @submit.prevent="addBarcode()">
          <v-card-text>
              <v-row>
               <v-col cols="12" v-for="(item, index) in unit_list" :key="index">
                  <v-row>
                     <v-col v-if="item.barcode != '-'" xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
                      <v-form-group>
                        <label class="label_form_text">เลขบาร์โค๊ด <span class="required--text">*</span></label>
                        <v-text-field readonly v-model="item.barcode" single-line outlined dense required type="text" :rules="[v => !!v || 'กรุณากรอกข้อมูล']"
                          placeholder="กรุณากรอกบาร์โค๊ด">
                          <!-- <template v-slot:append-outer>
                            <v-btn type="button" elevation="4" outlined color="#8EBBDC" style="border-radius: 10px;" @click="make_id(index)">
                              <v-icon>
                                mdi-barcode-scan
                              </v-icon>
                            </v-btn>
                          </template> -->
                        </v-text-field>
                      </v-form-group>
                    </v-col>
                    <v-col v-if="item.barcode != '-'" xs="12" sm="12" md="6" lg="6" xl="6" cols="12">
                      <v-row>
                        <v-col cols="8">
                          <v-form-group>
                          <label class="label_form_text"> ราคาขายปลีก  <span class="required--text">*</span></label>
                          <v-text-field v-model="item.price_standard" single-line outlined dense required clearable :rules="[v => !!v || 'กรุณากรอกข้อมูล']"
                            placeholder="กรุณากรอกราคาขายปลีก" type="text"></v-text-field>
                        </v-form-group>
                        </v-col>
                        <v-col cols="4">
                        <v-btn v-if="index != 0" type="button" outlined color="error" class="input-radius" @click="delete_unit(index);"
                            style=" min-width: 38px !important; padding: 0 9px !important; margin:25px auto auto auto !important; display: flex !important; justify-content: center !important; align-items: center !important;">
                            <v-icon>
                              mdi-delete
                            </v-icon>
                          </v-btn>
                      </v-col>
                      </v-row>
                    </v-col>
                    <v-col v-else xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                      <v-row>
                        <v-col cols="10">
                          <v-form-group>
                          <label class="label_form_text"> ราคาขายปลีก  <span class="required--text">*</span></label>
                          <v-text-field v-model="item.price_standard" single-line outlined dense required clearable :rules="[v => !!v || 'กรุณากรอกข้อมูล']"
                            placeholder="กรุณากรอกราคาขายปลีก" type="text"></v-text-field>
                        </v-form-group>
                        </v-col>
                        <v-col cols="2">
                        <v-btn v-if="index != 0" type="button" outlined color="error" class="input-radius" @click="delete_unit(index);"
                            style=" min-width: 38px !important; padding: 0 9px !important; margin:25px auto auto auto !important; display: flex !important; justify-content: center !important; align-items: center !important;">
                            <v-icon>
                              mdi-delete
                            </v-icon>
                          </v-btn>
                      </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
               </v-col>
                <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                  <div class="text-end">
                    <v-btn type="button" elevation="4" outlined color="#88B358" @click="addUnit()"
                      style="border-radius: 10px;">เพิ่มราคาขาย</v-btn>
                  </div>
                </v-col>
              </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn type="submit" class="btn_add_data_submit" elevation="4" large>บันทึก</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
            </v-form>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { isTelephone, taxNumber, validateEmail, onPaste } from "@/js/handler";
import { HTTP_ARIN } from "@/axios_arin";
export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Pos_inventory_list",
  data() {
    return {
      loading_page: true,
      search: '',
      tab_id: null,
      active_tab_id: 0,
      inventory_remove: false,
      price_new: false,
      dateRangeText: null,
      footer_Props: {
        'items-per-page-text': 'รายการต่อหน้า'
      },
      sub_menu: [
        {
          text: 'คลังสินค้า',
          disabled: false,
        },
        {
          text: 'ระบบ POS',
          disabled: false,
        },
        {
          text: 'คลังสินค้า',
          disabled: false,
          href: '#',
        },
      ],
      headers: [
        {
          text: 'รหัสสินค้า',
          value: 'product_code',
          fixed: true,
        },
        {
          text: 'ชื่อสินค้า',
          value: 'name',
          fixed: true,
        },
        {
          text: 'ชื่อทางการแพทย์',
          value: 'name_sci',
          fixed: true,
        },
        {
          text: 'จำนวน',
          value: 'in_stock',
          fixed: true,
        },
        {
          text: 'หน่วยนับ',
          value: 'unit_name',
          fixed: true,
        },
        {
          text: 'จัดการ',
          value: '',
          fixed: true,
          sortable: false,
        },
      ],
      product: [
        { id: 1, product_name: 'สินค้าทิ้ง', value: 2 },
        { id: 2, product_name: 'คลังใกล้หมดอายุ', value: 1 },
      ],
      data_list: [],
      barcode_del_list: [],
      export_type: null,
      export_count: null,
      detail: null,
      product_id: null,
      product_expired_store_id: null,
      menu: false,
      date_expired: null,
      add_unit_id: 1,
      unit_list: [{
        add_unit_id: this.add_unit_id,
        unit_id: null,
        unit_main: 0,
        barcode: '',
        price_standard: '',
      }],
    }
  },
  methods: {
    make_id(index) {
      this.unit_list[index].barcode = ''
      let characters_number = '0123456789';
      // let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let charactersLength = characters_number.length;
      for (let i = 0; i < 9; i++) {
        this.unit_list[index].barcode += characters_number.charAt(Math.floor(Math.random() * charactersLength));
      }
      let data = {
        barcode: this.unit_list[index].barcode
      }
       const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.post('/pos/storage/product/expired/barcode/check', data, config).then((res) => {
        if (res.data.successful === true) {
          if (res.data.status_check_barcode === true) {
            return true
          }else{
             this.make_id(index)
          }
          }
        })
    },
    delete_unit(index){
      this.barcode_del_list.push(this.unit_list[index].unit_id)
      this.unit_list.splice(index, 1)
    },
    link(link) {
      window.location.href = link;
    },
    inventory_remove_dialog() {
      this.inventory_remove = true;
    },
    price_new_dialog() {
      this.price_new = true;
      this.getBarcode()
    },
    tabs(number) {
      this.tab_id = number
      this.$store.commit('tabs', this.tab_id)
      if (number === 1) {
        this.active_tab_id = 0
        this.product= [
        { id: 1, product_name: 'สินค้าทิ้ง', value: 2 },
        { id: 2, product_name: 'คลังใกล้หมดอายุ', value: 1 },
      ],
         this.headers= [
        {
          text: 'รหัสสินค้า',
          value: 'product_code',
          fixed: true,
        },
        {
          text: 'ชื่อสินค้า',
          value: 'name',
          fixed: true,
        },
        {
          text: 'ชื่อทางการแพทย์',
          value: 'name_sci',
          fixed: true,
        },
        {
          text: 'จำนวน',
          value: 'in_stock',
          fixed: true,
        },
        {
          text: 'หน่วยนับ',
          value: 'unit_name',
          fixed: true,
        },
        {
          text: 'จัดการ',
          value: '',
          fixed: true,
          sortable: false,
        },
      ],
        this.getStockList()
      } else if (number === 2) {
        this.active_tab_id = 1
        this.product= [
        { id: 1, product_name: 'สินค้าทิ้ง', value: 2 },
      ],
         this.headers= [
        {
          text: 'ชื่อสินค้า',
          value: 'name',
          fixed: true,
        },
        {
          text: 'ชื่อทางการแพทย์',
          value: 'name_sci',
          fixed: true,
        },
        {
          text: 'จำนวน',
          value: 'in_stock',
          fixed: true,
        },
        {
          text: 'หน่วยนับ',
          value: 'unit_name',
          fixed: true,
        },
        {
          text: 'จัดการ',
          value: '',
          fixed: true,
          sortable: false,
        },
      ],
        this.getEXPStockList()
      }
    },
    isNumber: function (evt, number) {
      return isTelephone(evt, number)
    },
    isTaxNumber: function (evt, number) {
      return taxNumber(evt, number)
    },
    isEmail: function (evt) {
      return validateEmail(evt)
    },
    isPaste: function (evt) {
      return onPaste(evt)
    },
    async getBarcode() {
      // this.loading_page = true;
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.get('/pos/storage/product/expired/barcode/'+this.product_expired_store_id, config).then((res) => {
        if (res.data.successful === true) {
          this.unit_list = res.data.data;
          this.unit_list = this.unit_list.map(item => {
            return {
              add_unit_id: this.add_unit_id,
              unit_id: item.id,
              unit_main: 0,
              barcode: item.barcode,
              price_standard: item.price_retail,
            }
          });
          // this.loading_page = false;
        }
      })
    },
    async getStockList() {
      // this.loading_page = true;
      this.data_list = []
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.get('/pos/storage', config).then((res) => {
        if (res.data.successful === true) {
          this.data_list = res.data.product;
          this.loading_page = false;
        }
      })
    },
    async getEXPStockList() {
      // this.loading_page = true;
      this.data_list = []
      let link = this.date_expired != null ? '/pos/storage/product/expired?date_expired='+this.date_expired : '/pos/storage/product/expired?date_expired='
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.get(link, config).then((res) => {
        if (res.data.successful === true) {
          this.data_list = res.data.data;
          this.loading_page = false;
        }
      })
    },
    async exportInventory(){
     if(this.$refs.exportInventory.validate()){
          this.loading_page = true;
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      let data = {}
      if(this.tab_id == 1){
         data = {
        product_id : this.product_id,
        export_type : this.export_type ,
        export_count : this.export_count,
        detail : this.detail
      }
      }else{
          data = {
        product_expired_store_id : this.product_expired_store_id,
        product_id : this.product_id,
        export_type : this.export_type ,
        export_count : this.export_count,
        detail : this.detail
      }
      }
      let link = this.tab_id == 1 ? '/pos/storage/export' : '/pos/storage/product/expired/export/count'
      HTTP_ARIN.post(link, data, config).then((res) => {
        if (res.data.successful === true) {
          // this.getStockList()
          if(this.export_type == 1){
            this.$router.push('/arin/pos/exportproduct')
          }
          this.tabs(2)
          this.product_id = null
          this.export_type = null
          this.export_count = null
          this.inventory_remove = false;
          this.loading_page = false;
        }
      })
     }
    },

    addUnit() {
      this.add_unit_id += 1;
      this.unit_list.push({
        add_unit_id: this.add_unit_id,
        unit_id: null,
        unit_main: 0,
        barcode: '-',
        price_standard: '',
      })
    },

    addBarcode(){
        if(this.$refs.addBarcode.validate()){
          this.loading_page = true;
        const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
        let barcode_list = this.unit_list.map(o => {
          return {
            product_expired_id : this.product_expired_store_id,
            id : o.unit_id,
            barcode : o.barcode,
            price_retail : o.price_standard
          }
        })
        let data = {
          barcode_list: barcode_list,
          barcode_del_list :this.barcode_del_list
        }
        HTTP_ARIN.post('/pos/storage/product/expired/barcode/add', data, config).then(async(res) => {
          if (res.data.successful === true) {
            // await this.getEXPStockList()
            this.price_new = false;
            this.loading_page = false;
            // this.tab_id = 2;
            this.tabs(2);
          }
        })
        }
    },
    computed: {
      dateRangeText() {
        return this.dates.join(' ~ ')
      },
    },
  },
  // async created() {
  //    await this.getStockList()
  // },
  async mounted() {
    if(this.$store.state.tabs == 2){
      await this.tabs(2)
    }else{
      await this.tabs(1)
    }
  },
}
</script>

<style scoped>
.input-radius {
  border-radius: 10px;
}
</style>
